import { render, staticRenderFns } from "./TutorialView.vue?vue&type=template&id=f5130226&scoped=true"
import script from "./TutorialView.vue?vue&type=script&lang=js"
export * from "./TutorialView.vue?vue&type=script&lang=js"
import style0 from "./TutorialView.vue?vue&type=style&index=0&id=f5130226&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5130226",
  null
  
)

export default component.exports